module.exports = __webpack_public_path__ + "static/img/logo_jssnykxy.5d4d926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_jssnykxy.png
// module id = Bo7Z
// module chunks = 15